import React from "react"
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official'
import { Spinner } from 'reactstrap'
import { connect } from "react-redux"
import { useThemeContext } from '../contexts/ThemeContext';

const BarGraph = ({
  useGraphQuery,
  queryParams,
  defaultActiveTab = 1,
  scrollbar = false,
  direction = 'vertical',
  stacked = false,
  selectedCurrency,
  applyCurrencyConversion = true,
}) => {
  const { data, isLoading, isRefetching, isSuccess } = useGraphQuery(
    ...queryParams
  );
  const { isDark } = useThemeContext();
  const textColor = 'var(--text-primary)';
  const backgroundColor = 'transparent';

  const isHorizontal = direction === 'horizontal';
  const chartType = isHorizontal ? 'bar' : 'column';

  // For horizontal bars, we swap the axis titles
  // data may be a graphs array (from select transform) or raw response
  let graph = data?.data?.graphs?.[0] || data?.[0] || data;
  if (!graph) {
    graph = {};
  }
  const actualXAxisTitle = isHorizontal ? graph?.data?.yTitle : graph?.data?.xTitle;
  const actualYAxisTitle = isHorizontal ? graph?.data?.xTitle : graph?.data?.yTitle;

  const chartOptions = (graph) => {
    // Calculate height based on number of data points
    const dataPoints = graph?.data?.labels?.length || 0;
    const minHeight = 400; // Increased minimum height to match other charts
    const heightPerItem = 30; // Height per data point
    const dynamicHeight = Math.max(minHeight, dataPoints * heightPerItem);

    return {
      credits: { enabled: false },
      chart: {
        type: chartType,
        backgroundColor: backgroundColor,
        marginLeft: isHorizontal ? 150 : 50,
        height: isHorizontal ? dynamicHeight : minHeight, // Set minimum height for all charts
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: actualYAxisTitle,
          style: {
            color: textColor
          }
        },
        labels: {
          style: {
            color: textColor
          },
          useHTML: isHorizontal,
          x: isHorizontal ? -10 : 0
        },
        scrollbar: {
          enabled: scrollbar,
        },
      },
      xAxis: {
        categories: graph?.data?.labels,
        labels: {
          style: {
            color: textColor
         }
        },
        title: {
          text: actualXAxisTitle,
          style: {
            color: textColor
          }
        },
      },
      series: (graph?.data?.series || []).map(s => ({
        ...s,
        data: s.data.map(d => {
          const value = typeof d === 'number' && !isNaN(d) ? d : 0;
          const currencyMultiplier = applyCurrencyConversion ? (selectedCurrency?.value || 1) : 1;
          return Math.round(value * currencyMultiplier);
        }),
      })),
      plotOptions: {
        series: {
          stacking: (direction === 'horizontal' && !stacked) ? null : 'normal',
        },
        column: {
          borderColor: null
        },
        bar: {
          borderColor: null
        },
      },
    };
  };


  const dataPoints = graph?.data?.labels?.length || 0;
  const heightPerItem = 30;
  const minHeight = 400;
  const chartHeight = isHorizontal ? Math.max(minHeight, dataPoints * heightPerItem) : minHeight;
  const maxContainerHeight = 400;
  const needsScroll = isHorizontal && chartHeight > maxContainerHeight;

  return (
    <>
      {(isLoading || isRefetching) && (
        <Spinner
          color="primary"
          size="sm"
          style={{ position: "absolute", right: 20 }}
        />
      )}
      {isSuccess && (
        <>
          {
            data && (
              <div style={needsScroll ? { maxHeight: maxContainerHeight, overflowY: 'auto' } : undefined}>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={chartOptions(graph)}
                />
              </div>
            )
          }
        </>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  date: state.date,
  tenant: state.auth.tenant,
  selectedCurrency: state.currency.selectedCurrency,
});

export default connect(mapStateToProps)(BarGraph);
